import React, { useState, useEffect, useContext } from "react";
import "./Products.scss";
import ReactPaginate from "react-paginate";
import { BsFillStarFill } from "react-icons/bs";
import Countdown from "react-countdown";
import { ReactComponent as Featherclock } from "assets/images/featherclock.svg";
import { BsFillArrowUpCircleFill } from "react-icons/bs";
import { baseURL } from "constants/constants";
import { NavLink } from "react-router-dom";
import { useParams } from "react-router-dom";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import WithAuthentication from "Authentication/AuthenticationContext.ts";

// TODO : ask about price-discount in single sale api

const Products = ({ data, adminId, type, setLoading }) => {
  const products = data;
  const auth = useContext(WithAuthentication);
  const [id, setId] = useState();
  const [page, setPage] = useState(0);
  const [DisplaIitem, setDisplaIitem] = useState("");
  const [open, setOpen] = useState(false);
  const [productList, setProductList] = useState("");
  var intFrameWidth = window.innerWidth;
  // var itemperPage = 12;
  var itemperPage = intFrameWidth < 450 ? 8 : 16;
  const pageVisited = page * itemperPage;
  const handleAccordion = itemId => {
    if (open) {
      setOpen(!open);
      if (itemId === id) {
        return null;
      }
    }
    setOpen(prevValue => !prevValue);
    setId(itemId);
  };
  const sortRange = (range = []) => {
    let Range = [...range];
    return Range.sort((a, b) => a["from_price"] - b["from_price"]);
  };
  const sortRange2 = (range = []) => {
    let Range = [...range];
    let item = Range.find(item => item["is_active"] == 1);
    try {
      return item.from_price;
    } catch (error) {
      return "فروش تمام شد";
    }
    // return Range.find((item) => item["is_active"] == 1);
  };

  useEffect(() => {}, [page]);
  let bId = useParams();
  useEffect(() => {
    setProductList(
      products
        .map(item => {
          return returnProductItemBaseOnType(item);
        })
        .filter(i => i != null)
    );
    // setLoading(false);
  }, [products, id, open]);
  const returnProductItemBaseOnType = item => {
    if (
      (auth.userInfo.userType != -1 &&
        adminId != auth.userInfo.id &&
        item.info.is_single == "1" &&
        item.product_pricing?.length > 0 &&
        item.info.have_group_sale == 1) ||
      (auth.userInfo.userType != -1 &&
        adminId == auth.userInfo.id &&
        item.product_pricing?.length > 0)
    ) {
      return (
        <>
          {/* item.product_pricing?.length > 0 &&  */}
          {
            <div
              key={item.info.id}
              className="products card p-2 col-lg-3 col-md-4 col-sm-6 border-0 d-flex "
            >
              <div
                style={{ width: "240px", minHeight: "420px" }}
                // className={`product-wrapper  m-1 ${
                //   open && item.info.id === id ? "pt-0" : "pt-4"
                // }`}
                className="product-wrapper mx-auto pt-3"
              >
                {open && item.info.id === id && item.countdown && (
                  <div className="d-flex justify-content-center align-items-center mt-3 expanded-countdown pb-4">
                    <Countdown daysInHours={true} date={item?.countdown} />
                    <i className="me-2">
                      {<Featherclock className="expanded-clock" />}
                    </i>
                  </div>
                )}

                <div className="img-wrapper text-center position-relative">
                  <img
                    src={baseURL + item.info.cover[0].url}
                    alt={item.info.title}
                  />
                  {item.info.have_group_sale == 0 && (
                    <div
                      style={{ backgroundColor: "rgb(215 215 215 / 80%)" }}
                      className="position-absolute w-100 top-0 h-100 rounded d-flex justify-content-center align-items-center fs-2 "
                    >
                      <p
                        className="bg-secondary w-100"
                        style={{ color: "#ffb0a2" }}
                      >
                        غیـــرفعــال
                      </p>
                    </div>
                  )}
                </div>

                <div
                  style={{ paddingBottom: "20px" }}
                  className={`card-body m-2 ${
                    open && item.info.id === id ? "d-none" : ""
                  }`}
                >
                  <div className="mx-2 text-center" style={{ height: "35px" }}>
                    <span title={item.info.title} className="product-title">
                      {item.info.title}
                    </span>
                  </div>
                  <div
                    className="d-flex justify-content-center align-items-start flex-column text-right gap-2 mt-2"
                    style={{ height: 50 }}
                  >
                    <span className="maxprice ">
                      {/* {addCommas(item.info.main_price)} تومان  */}
                      حداکثر قیمت:
                      {item.product_pricing &&
                        addCommas(
                          sortRange(item.product_pricing)[
                            item.product_pricing.length - 1
                          ].from_price
                        )}{" "}
                      تومان
                    </span>

                    <span className="text-danger minprice">
                      حداقل قیمت :
                      {item.product_pricing &&
                        addCommas(
                          sortRange(item.product_pricing)[0].from_price
                        )}
                      {/* {item.sold <= 100
                      ? item.price - item.price * 0.25
                      : item.sold <= 200 && item.sold > 100
                      ? item.price - item.price * 0.5
                      : item.sold > 200 && item.price - item.price * 0.5} */}
                      تومان
                    </span>
                  </div>
                  <div
                    id="accordionExample"
                    className="d-flex justify-content-center align-items-center flex-column mt-3 text-center"
                  >
                    <button
                      onClick={() => {
                        handleAccordion(item.info.id);
                      }}
                      type="button"
                      className="morebutton px-4 py-2 shadow"
                    >
                      بیشتر
                    </button>
                  </div>
                </div>
                {open && item.info.id === id ? (
                  <div>
                    <div className="accordion-body d-flex flex-column mt-3">
                      <span className="text-center">{item.info.title}</span>

                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex justify-content-center align-items-center">
                          <span className="">قیمت : </span>
                          <span className="text-secondary">
                            {addCommas(sortRange2(item.product_pricing))}
                            {/* {item.info.main_price} */}
                          </span>
                        </div>
                        <div>
                          {/* <span className="expanded-discounted fw-bold">
                          {item.sold <= 100
                            ? item.price - item.price * 0.25
                            : item.sold <= 200 && item.sold > 100
                            ? item.price - item.price * 0.5
                            : item.sold > 200 && item.price - item.price * 0.5}
                        </span> */}
                          <span className="expanded-discounted "> تومان</span>
                        </div>
                      </div>
                      {/* range starts here */}
                      <div className="">
                        {/* range item */}
                        {item.product_pricing.map(value => {
                          return (
                            <>
                              <div
                                className={`d-flex justify-content-between align-items-center mt-4 ${
                                  +value.is_active
                                    ? "active-progress_active"
                                    : "text-secondary opacity-50"
                                }`}
                              >
                                <span>({value.to_count})</span>
                                <span>({value.from_count})</span>
                              </div>
                              <div dir="ltr" className="progress my-1 bg-light">
                                <div
                                  dir="ltr"
                                  id="progress-bar"
                                  className="progress-bar"
                                  role="progressbar"
                                  style={{
                                    width: `${(
                                      (value.saled_count * 100) /
                                      value.to_count
                                    ).toFixed(0)}% `
                                  }}
                                >
                                  {value.saled_count}
                                </div>
                              </div>
                              <div
                                className={`d-flex justify-content-center align-items-center 
                ${
                  +value.is_active
                    ? "active-progress_price"
                    : "deactive-progress_price"
                }`}
                              >
                                {/* <span>{addCommas(value.to_price)} تومان</span> */}
                                <span>{addCommas(value.from_price)} تومان</span>
                              </div>
                            </>
                          );
                        })}
                      </div>
                      {/* range ends here */}
                      <div className="d-flex justify-content-center">
                        <NavLink
                          to={`/product/${item.info.id}/${bId.businessId}/2`}
                          target="_blank"
                          // style={{ textAlign: "center" }}
                          className="text-center"
                        >
                          <button className="expanded-button shadow d-flex justify-content-center align-self-center align-items-center mt-4 text-light">
                            مشاهده محصول
                          </button>
                        </NavLink>
                      </div>
                      <i
                        onClick={() => setOpen(false)}
                        className="close-accordion mt-1 "
                      >
                        {<BsFillArrowUpCircleFill />}
                      </i>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          }
          {type == "1" && (
            <div
              key={item.info.id}
              className=" products card p-2 col-lg-3 col-md-4 col-sm-6 border-0 d-flex"
            >
              {/* <NavLink to={`/product/${item.info.id}/${bId.businessId}/1`}> */}
              <div
                style={{ width: "240px", minHeight: "420px" }}
                // className={`product-wrapper  m-1 ${
                //   open && item.info.id === id ? "pt-0" : "pt-4"
                // }`}
                className="product-wrapper mx-auto pt-3"
              >
                <div className="img-wrapper text-center  position-relative">
                  <img
                    src={baseURL + item.info.cover[0].url}
                    alt={item.title}
                  />
                  {item.info.is_single == 0 && (
                    <div
                      style={{ backgroundColor: "rgb(215 215 215 / 80%)" }}
                      className="position-absolute w-100 top-0 h-100 rounded d-flex justify-content-center align-items-center fs-2 "
                    >
                      <p
                        className="bg-secondary w-100"
                        style={{ color: "#ffb0a2" }}
                      >
                        غیـــرفعــال
                      </p>
                    </div>
                  )}
                </div>

                <div
                  // style={{ paddingBottom: "88px" }}
                  className="card-body m-2"
                  // className={`card-body m-2
                  //  ${
                  //   open && item.info.id === id ? "d-none" : ""
                  // }`}
                >
                  <div className="text-center mx-2 ">
                    <span
                      title={item.info.title}
                      className="product-title "
                      style={{ fontSize: "14px" }}
                    >
                      {item.info.title}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-start text-right gap-2 mt-3">
                    {item.info.main_discount != "0" ? (
                      <span className="maxprice text-decoration-line-through text-danger">
                        {addCommas(item.info.main_price)}
                      </span>
                    ) : (
                      <span></span>
                    )}
                    <span className=" minprice">
                      {addCommas(
                        item.info.main_price - item.info.main_discount
                      )}
                      تومان
                    </span>
                  </div>
                  <div
                    id="accordionExample"
                    className="d-flex justify-content-center align-items-center flex-column mt-3 text-center"
                  ></div>
                  <div className="d-flex justify-content-center">
                    <NavLink
                      to={`/product/${item.info.id}/${bId.businessId}/1`}
                      target="_blank"
                    >
                      <button className="expanded-button shadow d-flex justify-content-center align-self-center align-items-center mt-4 text-light">
                        مشاهده محصول
                      </button>
                    </NavLink>
                  </div>
                </div>
              </div>
              {/* </NavLink> */}
            </div>
          )}
        </>
      );
    }
    if (
      (auth.userInfo.userType != -1 &&
        adminId != auth.userInfo.id &&
        type == "1" &&
        item.info.is_single == "1" &&
        item.info.have_group_sale == 1) ||
      (auth.userInfo.userType != -1 &&
        adminId == auth.userInfo.id &&
        type == "1")
    ) {
      <div
        key={item.info.id}
        className=" products card p-2 col-lg-3 col-md-4 col-sm-6 border-0 d-flex"
      >
        {/* <NavLink to={`/product/${item.info.id}/${bId.businessId}/1`}> */}
        <div
          style={{ maxWidth: "250px", minHeight: "420px" }}
          // className={`product-wrapper  m-1 ${
          //   open && item.info.id === id ? "pt-0" : "pt-4"
          // }`}
          className="product-wrapper mx-auto pt-3"
        >
          <div className="img-wrapper text-center  position-relative">
            <img src={baseURL + item.info.cover[0].url} alt={item.title} />
            {item.info.is_single == 0 && (
              <div
                style={{ backgroundColor: "rgb(215 215 215 / 80%)" }}
                className="position-absolute w-100 top-0 h-100 rounded d-flex justify-content-center align-items-center fs-2 "
              >
                <p className="bg-secondary w-100" style={{ color: "#ffb0a2" }}>
                  غیـــرفعــال
                </p>
              </div>
            )}
          </div>

          <div
            // style={{ paddingBottom: "88px" }}
            className="card-body m-2"
            // className={`card-body m-2
            //  ${
            //   open && item.info.id === id ? "d-none" : ""
            // }`}
          >
            <div className="text-center mx-2 ">
              <span
                title={item.info.title}
                className="product-title "
                style={{ fontSize: "14px" }}
              >
                {item.info.title}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-start text-right gap-2 mt-3">
              {item.info.main_discount != "0" ? (
                <span className="maxprice text-decoration-line-through text-danger">
                  {addCommas(item.info.main_price)}
                </span>
              ) : (
                <span></span>
              )}
              <span className=" minprice">
                {addCommas(item.info.main_price - item.info.main_discount)}
                تومان
              </span>
            </div>
            <div
              id="accordionExample"
              className="d-flex justify-content-center align-items-center flex-column mt-3 text-center"
            ></div>
            <div className="d-flex justify-content-center">
              <NavLink
                to={`/product/${item.info.id}/${bId.businessId}/1`}
                target="_blank"
              >
                <button className="expanded-button shadow d-flex justify-content-center align-self-center align-items-center mt-4 text-light">
                  مشاهده محصول
                </button>
              </NavLink>
            </div>
          </div>
        </div>
        {/* </NavLink> */}
      </div>;
    }
    if (
      item.product_pricing &&
      item.info.have_group_sale == 1 &&
      item.info.is_single == "0"
    ) {
      return (
        <div
          key={item.info.id}
          className="products card p-2 col-lg-3 col-md-4 col-sm-6 border-0 d-flex "
        >
          <div
            style={{ width: "240px", minHeight: "420px" }}
            // className={`product-wrapper  m-1 ${
            //   open && item.info.id === id ? "pt-0" : "pt-4"
            // }`}
            className="product-wrapper mx-auto pt-3"
          >
            {open && item.info.id === id && item.countdown && (
              <div className="d-flex justify-content-center align-items-center mt-3 expanded-countdown pb-4">
                <Countdown daysInHours={true} date={item?.countdown} />
                <i className="me-2">
                  {<Featherclock className="expanded-clock" />}
                </i>
              </div>
            )}
            <div className="img-wrapper text-center">
              <img
                src={baseURL + item.info.cover[0].url}
                alt={item.info.title}
              />
            </div>

            <div
              className={`card-body m-2 ${
                open && item.info.id === id ? "d-none" : ""
              }`}
            >
              <div className="mx-2 text-center" style={{ height: "35px" }}>
                <span title={item.info.title} className="product-title ">
                  {item.info.title}
                </span>
              </div>
              <div
                className="d-flex justify-content-center align-items-start flex-column text-right gap-2 mt-2"
                style={{ height: 50 }}
              >
                <span className="maxprice ">
                  حداکثر قیمت:
                  {/* {addCommas(item.info.main_price)}  */}
                  {item.product_pricing &&
                    addCommas(
                      sortRange(item.product_pricing)[
                        item.product_pricing.length - 1
                      ].from_price
                    )}{" "}
                  تومان
                </span>

                <span className="text-danger minprice ">
                  حداقل قیمت :
                  {item.product_pricing &&
                    addCommas(sortRange(item.product_pricing)[0].from_price)}
                  {/* {item.sold <= 100
                    ? item.price - item.price * 0.25
                    : item.sold <= 200 && item.sold > 100
                    ? item.price - item.price * 0.5
                    : item.sold > 200 && item.price - item.price * 0.5} */}
                  تومان
                </span>
              </div>
              <div
                id="accordionExample"
                className="d-flex justify-content-center align-items-center flex-column mt-3 text-center"
              >
                <button
                  onClick={() => {
                    handleAccordion(item.info.id);
                  }}
                  type="button"
                  className="morebutton px-4 py-2 shadow"
                >
                  بیشتر
                </button>
              </div>
            </div>
            {open && item.info.id === id ? (
              <div>
                <div className="accordion-body d-flex flex-column mt-3">
                  <span className="text-center">{item.info.title}</span>

                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-center align-items-center">
                      <span className="">قیمت : </span>
                      <span className="text-decoration-line-through text-secondary">
                        {/* {addCommas(item.info.main_price)} */}
                        {addCommas(sortRange2(item.product_pricing))}
                      </span>
                    </div>
                    <div>
                      <span className="expanded-discounted fw-bold">
                        {/* {item.sold <= 100
                          ? item.price - item.price * 0.25
                          : item.sold <= 200 && item.sold > 100
                          ? item.price - item.price * 0.5
                          : item.sold > 200 && item.price - item.price * 0.5} */}
                      </span>
                      <span className="expanded-discounted "> تومان</span>
                    </div>
                  </div>
                  {/* range starts here */}
                  <div className="">
                    {/* range item */}
                    {/* {item.best_group_seller.map(value => { */}
                    {item.product_pricing &&
                      item.product_pricing.map((value, index) => {
                        return (
                          <>
                            <div
                              className={`d-flex justify-content-between align-items-center mt-4 ${
                                +value.is_active
                                  ? "active-progress_active"
                                  : "text-secondary opacity-50"
                              }`}
                            >
                              <span>({value.to_count})</span>
                              <span>({value.from_count})</span>
                            </div>
                            <div dir="ltr" className="progress my-1 bg-light">
                              <div
                                dir="ltr"
                                id="progress-bar"
                                className="progress-bar"
                                role="progressbar"
                                style={{
                                  width: `${(
                                    (value.saled_count * 100) /
                                    value.to_count
                                  ).toFixed(0)}% `
                                }}
                              >
                                {value.saled_count}
                              </div>
                            </div>
                            <div
                              className={`d-flex justify-content-center align-items-center 
                ${
                  +value.is_active
                    ? "active-progress_price"
                    : "deactive-progress_price"
                }`}
                            >
                              {/* {index == item.product_pricing.length - 1 ? (
                                <span>{addCommas(value.to_price)} تومان</span>
                              ) : (
                                <span></span>
                              )} */}
                              <span>{addCommas(value.from_price)} تومان</span>
                            </div>
                          </>
                        );
                      })}
                  </div>
                  {/* range ends here */}
                  <div className="d-flex justify-content-center">
                    <NavLink
                      to={`/product/${item.info.id}/${bId.businessId}/2`}
                      target="_blank"
                    >
                      <button className="expanded-button shadow d-flex justify-content-center align-self-center align-items-center mt-4 text-light">
                        مشاهده محصول
                      </button>
                    </NavLink>
                  </div>
                  <i
                    onClick={() => setOpen(false)}
                    className="close-accordion mt-1 "
                  >
                    {<BsFillArrowUpCircleFill />}
                  </i>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      );
    }
    if (
      type == "1" &&
      item.info.is_single == "1" &&
      item.info.have_group_sale == "0"
    ) {
      return (
        <div
          key={item.info.id}
          className=" products card p-2 col-lg-3 col-md-4 col-sm-6 border-0 d-flex"
        >
          {/* <NavLink to={`/product/${item.info.id}/${bId.businessId}/1`}> */}
          <div
            style={{ width: "240px", minHeight: "420px" }}
            // className={`product-wrapper  m-1 ${
            //   open && item.info.id === id ? "pt-0" : "pt-4"
            // }`}
            className="product-wrapper mx-auto pt-3"
          >
            <div className="img-wrapper text-center">
              <img
                src={baseURL + item.info.cover[0].url}
                alt={item.info.title}
              />
            </div>

            <div
              style={{ paddingBottom: "20px" }}
              // className={`card-body m-2 ${
              //   open && item.info.id === id ? "d-none" : ""
              // }`}
              className="card-body m-2"
            >
              <div className="text-center mx-2 ">
                <span
                  title={item.info.title}
                  className="product-title "
                  style={{ fontSize: "14px" }}
                >
                  {item.info.title}
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-start text-right gap-2 mt-3">
                {item.info.main_discount != "0" ? (
                  <span className="maxprice text-decoration-line-through text-danger">
                    {addCommas(item.info.main_price)}
                  </span>
                ) : (
                  <span></span>
                )}
                <span className=" minprice">
                  {addCommas(item.info.main_price - item.info.main_discount)}
                  تومان
                </span>
              </div>
              <div className="d-flex justify-content-center mt-2">
                <NavLink
                  to={`/product/${item.info.id}/${bId.businessId}/1`}
                  target="_blank"
                >
                  <button className="expanded-button shadow d-flex justify-content-center align-self-center align-items-center text-light mt-4">
                    مشاهده محصول
                  </button>
                </NavLink>
              </div>
              {/* <div
                  id="accordionExample"
                  className="d-flex justify-content-center align-items-center flex-column mt-3 text-center"
                ></div> */}
            </div>
          </div>
          {/* </NavLink> */}
        </div>
      );
    }
    if (item.info.is_single == "0" && item.info.have_group_sale == "0") {
      return null;
    }
  };

  // products.length>0 &&

  const displayItems = productList.slice(
    pageVisited,
    pageVisited + itemperPage
  );

  // const pageCount = Math.ceil(products.length / itemperPage);
  const pageCount = Math.ceil(productList.length / itemperPage);

  const handlePageClick = ({ selected }) => {
    setPage(selected);
  };

  return (
    <div className="mt-3">
      <div className="title d-flex justify-content-center fs-5">
        <span className=" ">محصولات</span>
      </div>
      <div className="container-fluid p-0">
        <div className="row p-0 m-0 p-2 ">
          {displayItems.length > 0
            ? displayItems
            : "در حال حاضر کالایی در این فروشگاه وجود ندارد"}
          {/* <ProductInfo data={data} /> */}
        </div>
        <div className="mx-auto mt-5" style={{ width: "fit-content" }}>
          <ReactPaginate
            breakLabel="..."
            nextLabel="بعدی"
            onPageChange={handlePageClick}
            pageRangeDisplayed={6}
            pageCount={pageCount}
            previousLabel="قبلی"
            renderOnZeroPageCount={null}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
          />
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default Products;
